import React from "react";
import "./Switch.scss";

export interface SwitchProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

function Switch(props: SwitchProps): React.JSX.Element {
  const {
    id,
    checked,
    onChange,
    disabled = false,
    className = ""
  } = props;
  return (
    <label
      className={`switch ${disabled ? 'disabled' : ''} ${className}`}
      role="switch"
      >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="slider"></span>
    </label>
  );
};

export default Switch;
